import React from 'react'
import { cn } from '@/utils'

export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

export const Loader = React.forwardRef<HTMLDivElement, LoaderProps>(
  ({ className, size = 'md', text, ...props }, ref) => {
    const sizes = {
      sm: 'h-4 w-4',
      md: 'h-6 w-6',
      lg: 'h-8 w-8'
    }

    return (
      <div
        ref={ref}
        className={cn('inline-flex flex-col items-center gap-2', className)}
        {...props}
      >
        <svg
          className={cn('animate-spin', sizes[size])}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        {text && (
          <span className="text-sm text-[var(--text)] opacity-60">{text}</span>
        )}
      </div>
    )
  }
)
Loader.displayName = 'Loader'

// Full screen loader variants
export const FullScreenLoader: React.FC<{ text?: string }> = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--background)]/80 backdrop-blur-sm">
    <Loader size="lg" text={text} />
  </div>
)

export const SectionLoader: React.FC<{ text?: string }> = ({ text }) => (
  <div className="flex min-h-[200px] items-center justify-center">
    <Loader size="md" text={text} />
  </div>
)

export default Loader 